'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/ProgressBar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressBar = function (_BcReactComponent) {
  _inherits(ProgressBar, _BcReactComponent);

  function ProgressBar(props) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));

    _this.state = {
      showMessaging: false
    };
    _this.timeout = null;
    return _this;
  }

  _createClass(ProgressBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Show a screen reader message when hiding the bar and hide the message when showing the bar
      if (nextProps.active !== this.props.active) {
        this.setState({
          showMessaging: this.props.active
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-progress-bar' },
        _react2.default.createElement('div', { className: 'bar ' + (this.props.active ? 'active' : '') }),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          { 'aria-live': 'polite', 'aria-atomic': 'true', role: 'region' },
          this.state.showMessaging && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_results_updated' })
        )
      );
    }
  }]);

  return ProgressBar;
}(_baseBcReactComponent2.default);

ProgressBar.propTypes = {
  active: _react.PropTypes.bool
};

exports.default = ProgressBar;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-progress-bar/lib/components/ProgressBar.component.js
// module id = 1238
// module chunks = 0